import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { InputField } from '../inputs/standard';

class UserTermsAndConditionsForm2 extends React.Component {
    componentDidMount() {}

    componentDidUpdate(prevProps) {}

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                {window.VULOG_ENABLE_PROMOCODE && (
                    <div className="form-row mb-4">
                        <label htmlFor="promo-code" className="blue small col-4 mb-0">
                            {window.VULOG_TRANSLATE('Promo Code')}
                        </label>
                        <div className="col">
                            <Field
                                component={InputField}
                                name={'promo-code'}
                                type="text"
                                className="form-control"
                                id="promo-code"
                            />
                        </div>
                    </div>
                )}
                {/*<div className="form-row pt-4 mb-2">*/}
                {/*<Field validate={[required]} name="agree_terms" component="input" type="checkbox" className="custom-checkbox" id="terms-and-conditions" />*/}
                {/*<label htmlFor="terms-and-conditions">{window.VULOG_TRANSLATE('I agree to the')} <a  href={this.props.terms}>{window.VULOG_TRANSLATE('Terms & Conditions')}</a></label>*/}
                {/*</div>*/}
                {/*<div className="form-row mb-2">*/}
                {/*<Field validate={[required]} name="agree_privacy" component="input" type="checkbox" className="custom-checkbox" id="privacy-conditions" />*/}
                {/*<label htmlFor="privacy-conditions">{window.VULOG_TRANSLATE('I agree to the')} <a href={this.props.privacy}>{window.VULOG_TRANSLATE('Privacy Conditions')}</a></label>*/}
                {/*</div>*/}
                {/*<div className="form-row mb-2">*/}
                {/*<Field name="subscribe" component="input" type="checkbox" className="custom-checkbox" id="subscribe" />*/}
                {/*<label htmlFor="subscribe">{window.VULOG_TRANSLATE('I want to be informed of the latest offers')}</label>*/}
                {/*</div>*/}
                {/*<div className="form-row mb-2">*/}
                {/*<Field validate={[required]} name="agree_claims" component="input" type="checkbox" className="custom-checkbox" id="two-claims" />*/}
                {/*<label htmlFor="two-claims">{window.VULOG_TRANSLATE('I declare that i have had no more than 2 claims (in fault) in the last 5 years.')}</label>*/}
                {/*</div>*/}
            </form>
        );
    }
}

export default reduxForm({
    // a unique name for the form
    form: 'user-terms',
})(UserTermsAndConditionsForm2);
